
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { customModal,treeView } from "@newview/ui";
import { UsercommonfunctionsApi } from "@newview/system-api";
import { debug } from "console";
@Component({
  name: "",
  components: {
    customModal,
    treeView
  },
})
export default class hdgxWelComeClass extends BaseVue {
  usercommonfunctionsApi:UsercommonfunctionsApi=new UsercommonfunctionsApi();
  functionList:any=[]
  funConfigModal=false
  menuTreeList:any=[]
  menudefaultList:any=[]
  selectedMenu:any=[]
  commonFunIds=""
  moduleIds:any=""
  async mounted() {
    let moduleData:any = await this.usercommonfunctionsApi.getListByUserId(this.$globalData_Plms.localUser.id)
    let data = moduleData.data;
    this.commonFunIds = this.Baselinq.from(data).select((item) => item["id"]).toArray().toString()
    this.moduleIds = this.Baselinq.from(data).select((item) => item["moduleId"]).toArray()
    let menuData: any = localStorage.getItem("MainMenuDatas");
    this.menuTreeList = this.Baselinq.from(JSON.parse(menuData)).where(e=>e["moduleName"]!="BIM应用").toArray();   
    this.formatTreeMenu(this.menuTreeList)
    this.loadFunList()
  }
  loadFunList(){
     this.functionList = this.Baselinq.from(this.menudefaultList).where((item)=>this.moduleIds.indexOf(item["id"])>=0).toArray()
  }
  formatTreeMenu(list){
    list.forEach((item,index) => {
      this.menudefaultList.push(item)
      item.title = item.moduleName
      if(item.children && item.children.length>0){
        item.disableCheckbox=true
        this.$set(item,"expand",true)
        this.formatTreeMenu(item.children)
      }else{
        if(this.moduleIds.indexOf(item.id)>=0){
          this.$set(item,"checked",true)
          this.selectedMenu.push(item)
        }        
        return
      }
    });
  }
  checkTree(list){
    this.selectedMenu.push(list)
  }
  removeSelectedFun(item,index){
    this.$set(item,"checked",false)
    this.selectedMenu.splice(index,1)
  }
  async saveFunList(){
    let CheckedNodes = this.ref("fun-tree").getCheckedNodes()
    let saveData:any =[]
    CheckedNodes.forEach(item => {
      saveData.push({
        moduleId:item['id'],
        userId:this.$globalData_Plms.localUser.id,
        subsystemId:this.$globalData_Plms.subSysteminfor.id,
        createTime:this.getCurrentDate("yyyy-MM-dd hh:mm:ss")
      })
    });
    this.moduleIds = this.Baselinq.from(CheckedNodes).select((item) => item['id']).toArray()
    this.usercommonfunctionsApi.savesFunctions(saveData).then(res=>{
      if(res.code ==200){
        this.loadFunList()
        this.funConfigModal=false
      }      
    }) 
  }
  menuClick(item){
    this.$emit("menuClickEvent",item)
  }
}
